/**
 * Suggestions de complément dans le tiroir de panier.
 *
 * L'écoute est déléguée au document : le tiroir est entièrement re-rendu par
 * la Section Rendering API à chaque ajout, ce qui détruirait des écouteurs
 * posés sur les boutons eux-mêmes.
 */
(() => {
  const SELECTEUR = '[data-terciart-suggestion-add]';

  document.addEventListener('click', async (evt) => {
    const bouton = evt.target.closest(SELECTEUR);
    if (!bouton) return;

    evt.preventDefault();
    if (bouton.getAttribute('aria-disabled') === 'true') return;

    const variantId = Number(bouton.dataset.variantId);
    const tiroir = document.querySelector('cart-drawer');
    if (!variantId || !tiroir) return;

    bouton.setAttribute('aria-disabled', 'true');
    bouton.classList.add('is-loading');

    try {
      const reponse = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: tiroir.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });

      const etat = await reponse.json();
      if (etat && etat.sections) {
        // Re-rend le tiroir : la barre de franco et les suggestions se mettent
        // à jour, et l'article ajouté disparaît de la liste.
        tiroir.renderContents(etat);
      } else {
        bouton.removeAttribute('aria-disabled');
        bouton.classList.remove('is-loading');
      }
    } catch (e) {
      console.error('Ajout de la suggestion impossible', e);
      bouton.removeAttribute('aria-disabled');
      bouton.classList.remove('is-loading');
    }
  });
})();
